import React from "react";
import {
  StyledFooter,
  ContactSection,
  EmergencyNumber,
  Icon,
  ServiceRules,
  Tooltip,
  TooltipWrapper,
} from "./styled";
import { FaPhoneAlt, FaArrowAltCircleRight, FaExclamationCircle } from "react-icons/fa";

export const Footer = () => (
  <StyledFooter>
    <ContactSection>
      <TooltipWrapper>
        <div>
          <Icon>
            <FaPhoneAlt />
          </Icon>
          <span>Helpdesk 1: 601 400 153</span>
          <Tooltip>
            ePAM <br />
            Formuły Cenowe<br />
            Aktualizacje <br />
          </Tooltip>
        </div>
      </TooltipWrapper>

      <TooltipWrapper>
        <div>
          <Icon>
            <FaPhoneAlt />
          </Icon>
          <span>Helpdesk 2: 661 630 765</span>
          <Tooltip>
            ProdCellWeb <br />
            Synchronizacja <br />
            Optymalizacja
          </Tooltip>
        </div>
      </TooltipWrapper>

      <TooltipWrapper>
        <div>
          <Icon>
            <FaPhoneAlt />
          </Icon>{" "}
          <span>Helpdesk 3: 605 999 437</span>
          <Tooltip>
            Faktury <br />
            Magazyn
          </Tooltip>
        </div>
      </TooltipWrapper>

      <TooltipWrapper>
        <EmergencyNumber>
          <Icon>
            <FaExclamationCircle />
          </Icon>
          <span>Telefon alarmowy: 661 569 109</span>
        </EmergencyNumber>
      </TooltipWrapper>
    </ContactSection>

    <ServiceRules>
      <a
        href="https://pamprojectpl.atlassian.net/wiki/spaces/DOK/pages/843939844/Zasady+Rejestracji+Czasu+Us+ug+Serwisowych"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Icon>
          <FaArrowAltCircleRight/>
        </Icon>
        Zasady świadczenia usług serwisowych
      </a>
    </ServiceRules>
  </StyledFooter>
);
